/**
 * MeSH WP Theme - Complianz RGAA accessibility fixes
 */

( function () {
	'use strict';

	// ---- Complianz RGAA: Focus trap in cookie modal ----
	function cmplzSetupFocusTrap() {
		var banner = document.querySelector( '.cmplz-cookiebanner' );
		if ( ! banner ) return;

		banner.addEventListener( 'keydown', function ( e ) {
			if ( e.key !== 'Tab' ) return;

			var focusableEls = banner.querySelectorAll(
				'button, [href], input:not([type="hidden"]), select, textarea, [tabindex]:not([tabindex="-1"]), summary, details'
			);
			var focusable = Array.prototype.filter.call( focusableEls, function ( el ) {
				return el.offsetParent !== null && ! el.disabled;
			} );

			if ( focusable.length === 0 ) return;

			var first = focusable[0];
			var last = focusable[ focusable.length - 1 ];

			if ( e.shiftKey ) {
				if ( document.activeElement === first ) {
					e.preventDefault();
					last.focus();
				}
			} else {
				if ( document.activeElement === last ) {
					e.preventDefault();
					first.focus();
				}
			}
		} );
	}

	// ---- Complianz RGAA: Move focus when "View preferences" reveals categories ----
	function cmplzSetupPreferencesFocus() {
		var viewPrefBtn = document.querySelector( '.cmplz-view-preferences' );
		if ( ! viewPrefBtn ) return;

		viewPrefBtn.addEventListener( 'click', function () {
			// Small delay to let Complianz reveal the categories
			setTimeout( function () {
				var categories = document.querySelector( '.cmplz-categories' );
				if ( categories && categories.offsetParent !== null ) {
					var firstFocusable = categories.querySelector( 'summary, input, button, [href], [tabindex]:not([tabindex="-1"])' );
					if ( firstFocusable ) {
						firstFocusable.focus();
					}
				}
			}, 100 );
		} );
	}

	// Initialize on page load and when Complianz shows the banner
	cmplzSetupFocusTrap();
	cmplzSetupPreferencesFocus();
	document.addEventListener( 'cmplz_cookie_banner_data', function () {
		cmplzSetupFocusTrap();
		cmplzSetupPreferencesFocus();
	} );

} )();
